import {TripCollection} from "../Trip";
import cohalm from "../../../assets/child/cohalm.jpg";

const dayChildCoh: TripCollection = {
    imageSrc: cohalm,
    trips: [
        {
            name: "5.1. Ţinutul Cohalmului I",
            route: "Braşov – Racoş – Mercheaşa – Rupea – Braşov",
            days: [
                [
                    {
                        locationName: "Complexul Geologic Racoş (Vulcanul Stins, Coloanele de Bazalt, Lacul de Smarald)",
                    },
                    {
                        locationName: "Stejarul Secular – “Bătrânul Carpaţilor”",
                    },
                    {
                        locationName: "Cetatea Rupea",
                    },
                ]
            ],
            notes: "Programul propune o excursie ce combină frumusețea naturii cu patrimoniul istoric al Transilvaniei. Vizita începe la Complexul Geologic Racoș, unde pot fi admirate Vulcanul Stins, Coloanele de Bazalt și Lacul de Smarald, adevărate minuni ale naturii ce oferă un peisaj spectaculos și unic. Urmează vizitarea Stejarului Secular, cunoscut ca „Bătrânul Carpaților”, un martor al trecerii timpului și simbol al rezistenței naturii. Excursia se încheie cu Cetatea Rupea, o fortificație impunătoare amplasată pe un deal vulcanic, care oferă panorame impresionante asupra împrejurimilor și o incursiune captivantă în istoria medievală a regiunii."
        },
        {
            name: "5.2. Ţinutul Cohalmului II",
            route:
                "Braşov – Racoş – Mercheaşa – Viscri – Rupea – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Complexul Geologic Racoş (Vulcanul Stins, Coloanele de Bazalt, Lacul de Smarald)",
                        },
                        {
                            locationName: "Stejarul Secular – “Bătrânul Carpaţilor”",
                        },
                        {
                            locationName: "Biserica Evanghelică Fortificată Viscri",
                        },
                        {
                            locationName: "Degustare Lichiu",
                        },
                        {
                            locationName: "Plimbare prin Satul Viscri",
                        },
                        {
                            locationName: "Cetatea Rupea",
                        },
                    ]
                ],
            notes:
                "Excursia propune o combinație fascinantă între natură, istorie și tradiții locale. Prima oprire este la Complexul Geologic Racoș, unde vizitatorii pot admira Vulcanul Stins, Coloanele de Bazalt și Lacul de Smarald, adevărate minuni naturale care oferă peisaje spectaculoase. Urmează Stejarul Secular, cunoscut drept „Bătrânul Carpaților”, simbol al rezistenței naturii și martor al trecerii timpului. În satul Viscri, vizitatorii descoperă Biserica Evanghelică Fortificată, monument UNESCO, și se bucură de o degustare tradițională de lichiu, experiment autentic al culturii locale. Excursia se încheie cu vizita la Cetatea Rupea, fortificație impresionantă situată pe un deal vulcanic, ce oferă panorame spectaculoase asupra împrejurimilor și o incursiune captivantă în istoria medievală a regiunii."
        }
        ,
        {
            name: "5.3. Ţinutul Cohalmului III",
            route:
                "Braşov – Viscri – Rupea – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Biserica Evanghelică Fortificată Viscri",
                        },
                        {
                            locationName: "Degustare Lichiu",
                        },
                        {
                            locationName: "Plimbare prin Satul Viscri",
                        },
                        {
                            locationName: "Cetatea Rupea",
                        },
                    ]
                ],
            notes:
                "Excursia oferă o experiență autentică în inima Transilvaniei, punând accent pe istorie și tradiții locale. În satul Viscri, vizitatorii descoperă Biserica Evanghelică Fortificată, monument UNESCO, simbol al comunității săsești și al arhitecturii medievale. Programul include și o degustare tradițională de lichiu, ocazie de a experimenta gustul autentic al culturii locale. Excursia se încheie cu vizita la Cetatea Rupea, fortificație impunătoare situată pe un deal vulcanic, care oferă panorame spectaculoase asupra împrejurimilor și o incursiune captivantă în istoria medievală a regiunii."
        }
        ,
    ]
}

export default dayChildCoh;